module.exports = __webpack_public_path__ + "img/file.0bff3b2b.svg";